import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pf-website/pf-website/app/utiq-verwalten/UtiqRevokeConsentLink.tsx");
